.navItem {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  height: var(--navbar-item-height);
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s;
  width: 100%;
}

.navItem:hover {
  background-color: var(--mantine-color-primary-4);
}

.active {
  background-color: transparent;
}
